import {
  BorderedWrapper,
  CustomCalendar,
  DisplayItemsPerPageSelect,
  Paginator,
  Search,
} from 'components';
import { StyledReferralRewardsList } from './styles';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-full.svg';
import { formateDate, formateTime } from 'utils';
import { useEffect, useState } from 'react';
import { TSortIReferralRewardByHeaderTitle } from 'types';
import { useAppDispatch } from 'store/store';
import { fetchReferralRewardsList } from 'store/thunks/userReferralThunks';
import { useSelector } from 'react-redux';
import {
  selectReferralRewards,
  referralRewardsListSetPage,
  setItemsPerReferralRewardsListPage,
  setReferralRewardsSearch,
  setReferralRewardsSort,
  setReferralRewardsDateFilter,
} from 'store/slices/userReferralSlice';
import { getNextSortDir } from 'utils';
interface IReferralRewardsListProps {
  children?: React.ReactNode;
}

export const ReferralRewardsList = ({ children }: IReferralRewardsListProps) => {
  const { rewards, pagesQuantity, currentPage, itemsPerPage } = useSelector(selectReferralRewards);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [sortBy, setSortBy] = useState<string | null>(null);
  const [sortDir, setSortDir] = useState<'ASC' | 'DESC' | 'NONE'>('NONE');

  const changeCurrentPageHandler = (nextPage: number) => {
    dispatch(referralRewardsListSetPage(nextPage));
    dispatch(fetchReferralRewardsList());
  };

  const changeItemsPerPageQuantityHandler = (itemsQuantity: number) => {
    dispatch(setItemsPerReferralRewardsListPage(itemsQuantity));
    dispatch(fetchReferralRewardsList());
  };

  const changeDateRangeHandler = (range: { from: Date; to: Date }) => {
    const fromDate = range.from.toISOString();
    const toDate = range.to.toISOString();
    dispatch(
      setReferralRewardsDateFilter({
        fromDate: fromDate === toDate ? null : fromDate,
        toDate: fromDate === toDate ? null : toDate,
      }),
    );
    dispatch(fetchReferralRewardsList());
  };

  const setSearchFilterHandler = (value: string) => {
    dispatch(setReferralRewardsSearch(value === '' ? null : value));
    dispatch(fetchReferralRewardsList());
  };

  const setSortHandler = (sortBy: {
    sortBy: TSortIReferralRewardByHeaderTitle;
    sortDir: 'ASC' | 'DESC' | 'NONE';
  }) => {
    dispatch(
      setReferralRewardsSort({
        sortBy: sortBy.sortDir === 'NONE' ? null : sortBy.sortBy,
        sortDir: sortBy.sortDir === 'NONE' ? null : sortBy.sortDir,
      }),
    );
    dispatch(fetchReferralRewardsList());
  };

  const sortHandler = (nextSortBy: TSortIReferralRewardByHeaderTitle) => {
    const nextSortDir = getNextSortDir(sortBy, nextSortBy, sortDir);
    setSortHandler({ sortBy: nextSortBy, sortDir: nextSortDir });
    setSortBy(nextSortBy);
    setSortDir(nextSortDir);
  };

  useEffect(() => {
    dispatch(fetchReferralRewardsList());
  }, []);
  return (
    <StyledReferralRewardsList>
      <BorderedWrapper>
        <div className="referral-list-controls-container">
          <h2 className="referral-list-heading">
            {t('referralsPage.referralRewardsList.heading')}
          </h2>
          <div className="referral-list-controls">
            <CustomCalendar onChange={changeDateRangeHandler} />
            <Search onChange={setSearchFilterHandler} />
          </div>
        </div>
        <div className="referral-list-container">
          <div className="referral-list-header">
            <div className="referral-list-header-element">
              <div>{t('referralsPage.referralRewardsList.header.dateTime')}</div>
              <button
                className="sort-by-button"
                onClick={() => sortHandler('date')}
                style={{
                  opacity: sortBy === 'date' && sortDir !== 'NONE' ? 1 : 0.6,
                  transform: `scale(${
                    sortBy === 'date' && sortDir !== 'NONE' ? '1.2' : '1'
                  }) rotateZ(${sortBy === 'date' && sortDir === 'ASC' ? '180deg' : '0deg'})`,
                }}
              >
                <ArrowDownIcon className="sort-icon" />
              </button>
            </div>
            <div className="referral-list-header-element">
              <div>{t('referralsPage.referralRewardsList.header.amount')}</div>
              <button
                className="sort-by-button"
                onClick={() => sortHandler('amount')}
                style={{
                  opacity: sortBy === 'amount' && sortDir !== 'NONE' ? 1 : 0.6,
                  transform: `scale(${
                    sortBy === 'amount' && sortDir !== 'NONE' ? '1.2' : '1'
                  }) rotateZ(${sortBy === 'amount' && sortDir === 'ASC' ? '180deg' : '0deg'})`,
                }}
              >
                <ArrowDownIcon className="sort-icon" />
              </button>
            </div>
          </div>
          <div className="referral-list-body">
            {rewards.map((reward) => {
              const elementdate = new Date(reward.date);
              return (
                <div key={reward.id} className="referral-list-row">
                  <div className="referral-list-element date">
                    <span>{formateDate(elementdate)}</span>
                    <span className="time">
                      &nbsp;-&nbsp;
                      {`${formateTime(elementdate)}`}
                    </span>
                  </div>
                  <div className="referral-list-element sum">{reward.amount}</div>
                </div>
              );
            })}
          </div>
          {pagesQuantity > 0 && (
            <div className="pagination-container">
              <Paginator
                currentPage={currentPage}
                pageQuantity={pagesQuantity}
                onChange={changeCurrentPageHandler}
              />
              <DisplayItemsPerPageSelect
                onChange={changeItemsPerPageQuantityHandler}
                currentItemsPerPageQuantity={itemsPerPage}
              />
            </div>
          )}
        </div>
      </BorderedWrapper>
    </StyledReferralRewardsList>
  );
};
